export default "__VITE_ASSET__b2250b68__"